<template>
  <div class="product-recommanded row">
    <h3 class="text-center title-prod-rec" v-html="$sanitize.sanitizeI18nContent($t('product_recommanded.title'))"></h3>
    <!--<ProductCard v-for="product in ProductsRec" :key="product.id" :product="product" />-->
    <div class="col col-lg-11 col-md-11 col-sm-11">
      <div v-if="ProductsRec.length > 0" class="carousel__wrapper">
        <Carousel v-bind="carouselConfig">
          <Slide v-for="product in ProductsRec" :key="product.id">
            <ProductCardSlide :product="product" />
          </Slide>

          <template #addons>
            <Navigation />
          </template>
        </Carousel>
      </div>
    </div>
  </div>
</template>

<script>
  //import ProductCard from './ProductCard.vue';
  import ProductCardSlide from "./ProductCardSlide.vue";
  import "vue3-carousel/carousel.css";
  import { Carousel, Slide, Navigation } from "vue3-carousel";

  export default {
    name: "ProductRecommanded",
    components: {
      //ProductCard,
      ProductCardSlide,
      Carousel,
      Slide,
      Navigation,
    },
    props: {
      ProductsRec: {
        type: Array,
        required: true,
      },
    },
    computed: {
      carouselConfig() {
        const shouldLoop = (this.ProductsRec || []).length >= 4;
        return {
          itemsToShow: 4,
          snapAlign: "start",
          gap: 40,
          autoplay: 4000,
          autoplayHoverPause: true,
          loop: shouldLoop,
          wrapAround: shouldLoop,
          pauseAutoplayOnHover: true,
          breakpoints: {
            0: { itemsToShow: 1, snapAlign: "start", loop: shouldLoop, wrapAround: shouldLoop },
            400: { itemsToShow: 2, snapAlign: "start", loop: shouldLoop, wrapAround: shouldLoop },
            600: { itemsToShow: 2, snapAlign: "start", loop: shouldLoop, wrapAround: shouldLoop },
            992: { itemsToShow: 4, snapAlign: "start", loop: shouldLoop, wrapAround: shouldLoop },
          },
        };
      },
    },
  };
</script>

<style scoped>
  .product-recommanded {
    margin-top: 20px;
  }
  .title-prod-rec {
    color: #1e347d;
    font-weight: 900;
    line-height: 55px;
    font-size: 38px;
    font-style: normal;
    justify-content: center;
  }
  @media (max-width: 768px) {
    .title-prod-rec {
      font-size: 17px;
      line-height: 30px;
    }
  }

  .carousel {
    --vc-nav-background: rgba(255, 255, 255, 0.7);
    --vc-nav-border-radius: 100%;
  }
  .carousel__wrapper {
    padding: 2px;
    position: relative;
    margin: 0 auto;
  }
  :deep(.carousel__icon) {
    fill: #1e347d;
    height: 70%;
  }
  :deep(.carousel__next),
  :deep(.carousel__prev) {
    top: 38%;
    border: 1px solid #1e347d !important;
    background: #eff1f7;
  }
  :deep(.carousel__next:hover),
  :deep(.carousel__prev:hover) {
    background: #c9cfde;
  }
  :deep(.carousel__prev) {
    left: -4% !important;
  }
  :deep(.carousel__next) {
    right: -4% !important;
  }
</style>
